module.exports = __webpack_public_path__ + "static/img/reward3-shadowed.c1dcdeb8.png";